const actions = {
	
	FETCH_BILL_BEGIN: 'FETCH_BILL_BEGIN',
	FETCH_BILL_SUCCESS: 'FETCH_BILL_SUCCESS',
	FETCH_BILL_ERR: 'FETCH_BILL_ERR',

	CONFIRM_BILL_BEGIN: 'CONFIRM_BILL_BEGIN',
	CONFIRM_BILL_SUCCESS: 'CONFIRM_BILL_SUCCESS',
	CONFIRM_BILL_ERR: 'CONFIRM_BILL_ERR',

	fetchBillBegin: () => {
		return {
			type: actions.FETCH_BILL_BEGIN,
		};
	},

	fetchBillSuccess: (data) => {
		return {
			type: actions.FETCH_BILL_SUCCESS,
			data,
		};
	},

	fetchBillErr: (err) => {
		return {
			type: actions.FETCH_BILL_ERR,
			err,
		};
	},

	confirmBillBegin: () => {
		return {
			type: actions.CONFIRM_BILL_BEGIN,
		};
	},

	confirmBillSuccess: (data) => {
		return {
			type: actions.CONFIRM_BILL_SUCCESS,
			data,
		};
	},

	confirmBillErr: (err) => {
		return {
			type: actions.CONFIRM_BILL_ERR,
			err,
		};
	},

};

export default actions;
